/*global chrome*/
import React, { useState, useEffect } from 'react';
import CastProvider from './cast/CastProvider';
import './App.css';
import ScriptTag from 'react-script-tag';
import ReactDOM from "react-dom/client";
import TR from './Trans';
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import MuvikaApp from './components/pages/MuvikaApp';
import Login from './components/pages/Login';
import Register from './components/pages/Register';
import StartRegister from './components/pages/StartRegister';
import CreateAccount from './components/pages/CreateAccount';
import { getOS, getPlatform, isDesktop, isPhone, isTablet, isSamsungBrowser } from './services/os';
import ForgotPassword from './components/pages/ForgotPassword';
import SongbookLogin from './components/pages/SongbookLogin';
import SongbookApp from './components/pages/SongbookApp';
import ExternalView from './components/player/ExternalView';
import NewAccount from './components/pages/NewAccount';
import WaitingAccount from './components/pages/WaitingAccount';
import ForceAcceptTerms from './components/pages/ForceAcceptTerms';
import ForceChangePassword from './components/pages/ForceChangePassword';
import { useLocalStorage } from './services/useLocalStorage';
import muvikaAttrs from './attrs';

function ScrollManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Prevent default scroll restoration
    window.history.scrollRestoration = 'manual';
  }, [pathname]);

  return null;
}

function App() {

  return (
    <CastProvider>
      <HashRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<MuvikaApp />} />
          <Route path="/login" element={<Login />} />
          <Route path="/startregister" element={<Register />} />
          <Route path="/register" element={<StartRegister />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/createaccount" element={<CreateAccount />} />
          <Route path="/songs" element={<SongbookLogin />} />
          <Route path="/songbook" element={<SongbookApp />} />
          <Route path="/newaccount" element={<NewAccount />} />
          <Route path="/waitingaccount" element={<WaitingAccount />} />
          <Route path="/forcechangepassword" element={<ForceChangePassword />} />
          <Route path="/forceacceptterms" element={<ForceAcceptTerms />} />
        </Routes>
      </HashRouter>
    </CastProvider>
  );
}

export default App;
